import React from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";

const COLORS = [
  { hex: "#C5A059", label: "Antique Gold" },
  { hex: "#F4EBD9", label: "Cream Ivory" },
  { hex: "#9CA986", label: "Soft Sage" },
  { hex: "#E9A2AF", label: "Blush Pink" },
  { hex: "#2C2A29", label: "Charcoal" },
];

export default function DressCode() {
  return (
    <Section testId="dress-code-section" className="bg-cream/30">
      <SectionTitle overline="Attire" title="Dress" italic="Code" />

      <Reveal>
        <p className="text-center text-charcoal/70 max-w-md mx-auto mb-10 font-serif italic">
          Mohon kenakan busana dengan palet warna berikut untuk menyelaraskan kebahagiaan kami.
        </p>
      </Reveal>

      <div className="flex flex-wrap justify-center gap-8 md:gap-10" data-testid="dress-code-swatches">
        {COLORS.map((c, i) => (
          <Reveal key={c.hex} delay={i * 0.08} className="text-center">
            <div
              className="w-20 h-20 md:w-24 md:h-24 rounded-full mx-auto mb-3 border border-gold/30 shadow-sm"
              style={{ backgroundColor: c.hex }}
              data-testid={`swatch-${c.label.toLowerCase().replace(/\s/g, "-")}`}
            />
            <p className="text-xs tracking-[0.25em] uppercase text-gold">{c.label}</p>
            <p className="text-xs text-charcoal/50 font-mono mt-1">{c.hex}</p>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
